/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Gesamtschule_Konradsdorf2Inputs */

const en__field_enum_gesamtschule_konradsdorf2 = /** @type {(inputs: _Field_Enum_Gesamtschule_Konradsdorf2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konradsdorf`)
};

const de__field_enum_gesamtschule_konradsdorf2 = /** @type {(inputs: _Field_Enum_Gesamtschule_Konradsdorf2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtschule Konradsdorf`)
};

/**
* | output |
* | --- |
* | "Konradsdorf" |
*
* @param {_Field_Enum_Gesamtschule_Konradsdorf2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_gesamtschule_konradsdorf2 = /** @type {((inputs?: _Field_Enum_Gesamtschule_Konradsdorf2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Gesamtschule_Konradsdorf2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_gesamtschule_konradsdorf2(inputs)
	return de__field_enum_gesamtschule_konradsdorf2(inputs)
});
export { _field_enum_gesamtschule_konradsdorf2 as "_field_enum_Gesamtschule_Konradsdorf" }